import {
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  Snackbar,
} from "@mui/material";
import { Container } from "@mui/system";
import React, { useState } from "react";
import Page from "../components/Page";
import MuiAlert from "@mui/material/Alert";
import moment from 'moment';
import {
  MoivimientosList,
  MovimientosListHead,
} from "../sections/@dashboard/movimientos";
const Movimientos = () => {
  const TABLE_HEAD = [
    { id: "turno", label: "Turno", alignRight: false },
    { id: "diaTrabajo", label: "Día", alignRight: false },
    { id: "fechaTrabajo", label: "Fecha de Trabajo", alignRight: false },
    { id: "fechaReporte", label: "Fecha de Reporte", alignRight: false },
    { id: "delegado", label: "Delegado", alignRight: false },
    { id: "plaza", label: "Plaza", alignRight: false },
    { id: "monto", label: "Monto", alignRight: false },
    { id: "comision", label: "Comisión", alignRight: false },
    { id: "neto", label: "Neto", alignRight: false },
    { id: "userId", label: "Usuario Registró", alignRight: false },
  ];
  const [openDialog, setOpenDialog] = useState(false);
  const [mes, setMoth] = useState(moment());
  console.log()
  const [title, setTitle] = useState("");
  const [bodyDialog, setBodyDialog] = useState("");
  const [closeDialog, setCloseDialog] = useState(false);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [errorGraph, setErrorGraph] = useState({
    severity: "",
    mensaje: "",
  });
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackBar(false);
  };

  return (
    <Page title="Movimientos">
      <Container maxWidth="xl">
        <MovimientosListHead
          setOpenDialog={setOpenDialog}
          setBodyDialog={setBodyDialog}
          setTitle={setTitle}
          setErrorGraph={setErrorGraph}
          setMoth={setMoth}
          setOpenSnackBar={setOpenSnackBar}
          mes={mes}
        />
        <Card>
          <MoivimientosList
            headLabel={TABLE_HEAD}
            setOpenDialog={setOpenDialog}
            setBodyDialog={setBodyDialog}
            setErrorGraph={setErrorGraph}
            setOpenSnackBar={setOpenSnackBar}
            mes={mes}
          />
        </Card>
      </Container>
      <Dialog open={openDialog} fullWidth maxWidth={"md"}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>{bodyDialog}</DialogContent>
      </Dialog>
      <Snackbar
        open={openSnackBar}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={errorGraph.severity}
          sx={{ width: "100%" }}
        >
          {errorGraph.mensaje}
        </Alert>
      </Snackbar>
    </Page>
  );
};

export default Movimientos;
